import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {dashboardGetCoursesCheckedin, signoutToCourse} from '../../../Courses/actions';
import DashboardCoursesListItem from "./DashboardCoursesListItem";
import CoursesListItemPlaceholder from "../../../Courses/components/List/CoursesListItemPlaceholder";
import Button from "@material-ui/core/Button";
import LoadingSpinner from "../../../Layout/components/LoadingSpinner";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DoneIcon from "../../../../../node_modules/@material-ui/icons/Done";
import ReactHtmlParser from "react-html-parser";
import '../../../Courses/assets/scss/dialogCourseCheckin.css';

class DashboardCoursesList extends Component {
    state = {
        initialLoad: true,
        courseToUnsubscribe: {},
        dialogCheckinUnsubscribeOpen: false,
        dialogCheckinUnsubscribeConfirmOpen: false,
    };

    componentDidMount() {
        // Fetch the courses where the current logged in user is checked in
        this.props.dashboardGetCoursesCheckedin(
            1, // No offset
            true, // Reset the search results / listing
        );
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.signupOrOut !== this.props.signupOrOut) {
            if (this.props.signupOrOut && this.state.dialogCheckinUnsubscribeOpen) {
                // The user want to unsubscribe, and has been just unsubscribed (signed out)
                // Hide the unsubscribe dialog, and show the confirmation dialog.
                this.setState({
                    courseToUnsubscribe: {},
                    dialogCheckinUnsubscribeOpen: false,
                    dialogCheckinUnsubscribeConfirmOpen: true,
                });

                // Reload the courses
                this.props.dashboardGetCoursesCheckedin(
                    1, // No offset
                    true, // Reset the search results / listing
                );
            }
        }
    }

    loadMore = (e) => {
        e.preventDefault();

        const {dashboardCoursesLoading, hasMore, currentPage} = this.props.courses;

        if (hasMore && !dashboardCoursesLoading) {
            this.setState({initialLoad: false});

            this.props.dashboardGetCoursesCheckedin(currentPage + 1);
            // TODO search criteria
        }
    };

    handleSlickUnsubscribe = (course) => {
        this.setState({
            courseToUnsubscribe: course,
            dialogCheckinUnsubscribeOpen: true,
        });
    };

    handleSignout = (e) => {
        e.preventDefault();

        this.props.signoutToCourse(this.state.courseToUnsubscribe.slug);
    };

    closeDialog = (name) => () => {
        this.setState({ ['dialog' + name + 'Open']: false });
    };

    render() {
        const {dashboardCoursesCheckedin, dashboardCoursesLoading, hasMore} = this.props.courses;
        const {signupOrOutLoading} = this.props;

        let placeholders = [];

        for (let i = 0; i < 8; i++) {
            placeholders.push(<CoursesListItemPlaceholder key={i}/>);
        }

        let courses = [];
        if (!dashboardCoursesLoading) {
            if (this.props.filter === 'checkedin') {
                courses = dashboardCoursesCheckedin;
            } else if (this.props.filter === 'author') {
                courses = dashboardCoursesLoading;
            }
        }

        let courseToUnsubscribeTitle = '';
        if (Object.keys(this.state.courseToUnsubscribe).length) {
            courseToUnsubscribeTitle = this.state.courseToUnsubscribe.title;
            if (this.state.courseToUnsubscribe.title_html !== '' && this.state.courseToUnsubscribe.title_html !== null) {
                courseToUnsubscribeTitle = ReactHtmlParser(this.state.courseToUnsubscribe.title_html);
            }
        }

        return (
            <Fragment>
                <section id="courses-list">
                    <div className="row">
                        {(dashboardCoursesLoading && this.state.initialLoad) && placeholders}
                        {!dashboardCoursesLoading && Array.isArray(courses) && courses.map(course => (
                            <DashboardCoursesListItem key={course.id} course={course} handleSlickUnsubscribe={this.handleSlickUnsubscribe} />
                        ))}
                        {(!dashboardCoursesLoading && (courses.length === 0 || !Array.isArray(courses))) &&
                        <div className="col col-12 text-center">
                            {this.props.filter === 'checkedin' &&
                                <p>Il n'y a aucune formation à laquelle vous vous êtes inscrit(e).</p>
                            }
                            {this.props.filter === 'author' &&
                                <p>Il n'y a aucune formation que vous gérez.</p>
                            }
                        </div>
                        }
                        {(dashboardCoursesLoading && !this.state.initialLoad) && placeholders}
                    </div>
                    {(hasMore && !dashboardCoursesLoading) &&
                    <div className="row row-more">
                        <div className="col-3 mx-auto">
                            <div className="text-center">
                                <Button variant="contained" color="primary" size="medium" onClick={this.loadMore} className="btn-more">
                                    Charger plus...
                                </Button>
                            </div>
                        </div>
                    </div>
                    }
                    {((courses === null || dashboardCoursesLoading) && !this.state.initialLoad) &&
                    <div className="row row-loading">
                        <div className="col-3 mx-auto">
                            <div className="text-center">
                                <LoadingSpinner/>
                            </div>
                        </div>
                    </div>
                    }
                </section>
                <Dialog
                    open={this.state.dialogCheckinUnsubscribeOpen}
                    onClose={this.closeDialog('CheckinUnsubscribe')}
                    aria-labelledby="dialog-checkin-unsubscribe-title"
                    className="dialog-course-checkin"
                >
                    <DialogContent className="dialog-checkin-content">
                        <div id="dialog-checkin-unsubscribe-title">
                            <span className="title">Se désinscrire de</span>
                            <span className="subtitle">{courseToUnsubscribeTitle}</span>
                        </div>
                        <div className="buttons">
                            {signupOrOutLoading ? (
                                <LoadingSpinner align="center" />
                            ) : (
                                <Fragment>
                                    <Button onClick={this.handleSignout} className="btn btn-confirm" variant="contained" color="primary" size="large" autoFocus>
                                        <DoneIcon className="icon" />
                                        Confirmer
                                    </Button>
                                    <br />
                                    <Button onClick={this.closeDialog('CheckinUnsubscribe')} className="btn btn-cancel" variant="outlined" color="secondary" size="large">
                                        Annuler
                                    </Button>
                                </Fragment>
                            )}
                        </div>
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={this.state.dialogCheckinUnsubscribeConfirmOpen}
                    onClose={this.closeDialog('CheckinUnsubscribeConfirm')}
                    aria-labelledby="dialog-checkin-unsubscribe-confirm-title"
                    className="dialog-course-checkin"
                >
                    <DialogContent className="dialog-checkin-content">
                        <div id="dialog-checkin-unsubscribe-confirm-title">
                            <span className="title">Merci !</span>
                            <span className="subtitle">Votre désinscription<br />est bien confirmée</span>
                        </div>
                        <div className="buttons">
                            <Button onClick={this.closeDialog('CheckinUnsubscribeConfirm')} className="btn btn-cancel" variant="outlined" color="secondary" size="large">
                                Fermer
                            </Button>
                        </div>
                    </DialogContent>
                </Dialog>
            </Fragment>
        );
    }
}

DashboardCoursesList.propTypes = {
    signoutToCourse: PropTypes.func.isRequired,
    dashboardGetCoursesCheckedin: PropTypes.func.isRequired,
    changeFilter: PropTypes.func.isRequired,
    filter: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
    courses: state.courses,
    signupOrOut: state.courses.courseSignupOrOut,
    signupOrOutLoading: state.courses.courseSignupOrOutLoading,
    signupOrOutError: state.courses.courseSignupOrOutError,
});

export default connect(mapStateToProps, {dashboardGetCoursesCheckedin, signoutToCourse})(DashboardCoursesList);


// WEBPACK FOOTER //
// ./src/features/Dashboard/components/Courses/DashboardCoursesList.js